import { SearchInput } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { getTraceabilityRequestsQueryParams } from "@tfg/types/schemas/traceabilityRequests"

interface Props {
  filters: Exclude<getTraceabilityRequestsQueryParams["filters"], undefined>
  setFilters: Dispatch<
    SetStateAction<
      Exclude<getTraceabilityRequestsQueryParams["filters"], undefined>
    >
  >
}

export const RequestSearch = ({ filters, setFilters }: Props) => {
  const { t } = useTranslation(["traceability"])

  return (
    <SearchInput
      autoFocus
      w={180}
      inputValue={filters?.search ?? ""}
      onChange={(value) =>
        setFilters((prev) => ({ ...prev, search: value.toString() }))
      }
      placeholder={t("filters.search")}
    />
  )
}
